<ng-container *ngFor="let menuItem of sideMenuItems">
  <a
    *ngIf="deviceInfo.deviceTypeDetected === 'DESKTOP' || menuItem.showOnMobile"
    class="menu-item {{ menuItem.class }}"
    #linkRef
    [routerLink]="menuItem.isDisabled(myProcess?.status) ? null : menuItem.getRouterLink(myProcess?.id)"
    routerLinkActive="active"
    [attr.aria-current]="rla.isActive ? 'page' : null"
    [attr.aria-disabled]="menuItem.isDisabled(myProcess?.status) ? 'true' : null"
    [attr.tabindex]="menuItem.isDisabled(myProcess?.status) ? -1 : 0"
    [class.item-disabled]="menuItem.isDisabled(myProcess?.status)"
    #rla="routerLinkActive"
    nz-tooltip
    [nzTooltipTrigger]="
      isForeigner &&
      menuItem.disabledItemTooltip &&
      (!myProcess?.id || myProcess?.id === 'purchase' || myProcess?.id === 'articles')
        ? 'click'
        : null
    "
    nzTooltipTitle="{{
      menuItem.disabledItemTooltip && menuItem.isDisabled(myProcess?.status)
        ? (menuItem.disabledItemTooltip | translate)
        : ''
    }}"
    nzTooltipPlacement="right"
    nzTooltipOverlayClassName="disabled-menu-item-tooltip"
    [nzTooltipArrowPointAtCenter]="true"
    (keydown.space)="$event.preventDefault(); linkRef.click()">
    <mat-icon *ngIf="menuItem.svgIcon" class="menu-item-icon" [svgIcon]="menuItem.svgIcon" aria-hidden="true">
    </mat-icon>

    <span>{{ menuItem.mainLabelKey | translate }}</span>
  </a>
</ng-container>

<!-- ARTICLES button - Completely different behaviour. Hardcoding for now. -->
<!-- Visible only to foreigners -->
<a
  *ngIf="!initInProgress && isForeigner"
  class="menu-item"
  #articlesLink
  tabindex="0"
  role="button"
  (click)="openArticlesModal()"
  (keydown.enter)="openArticlesModal()"
  (keydown.space)="$event.preventDefault(); articlesLink.click()"
  [class.active]="!!articlesModalRef"
  [attr.aria-expanded]="articlesModalRef ? 'true' : 'false'"
  aria-haspopup="dialog"
  nz-tooltip
  #articleHintTooltipWrap="nzTooltip"
  [nzTooltipTitle]="ArticlesHintTooltip"
  [nzTooltipVisible]="!initInProgress && deviceInfo?.deviceTypeDetected === 'DESKTOP' && !seenArticlesHint"
  nzTooltipPlacement="right"
  nzTooltipOverlayClassName="articles-hint-tooltip"
  [nzTooltipArrowPointAtCenter]="true"
  [nzTooltipTrigger]="null">
  <mat-icon class="menu-item-icon" [svgIcon]="'document'" aria-hidden="true"> </mat-icon>

  <span>{{ 'COMMON.LAYOUT.ARTICLES' | translate }}</span>
</a>

<ng-template #ArticlesHintTooltip>
  <div class="articles-hint-wrapper" role="tooltip">
    <div class="hint-row">
      {{ 'ARTICLES.GENERAL_HINT' | translate }}
    </div>

    <button
      type="button"
      class="close-hint-button"
      (click)="closeArticlesHint('X_BUTTON')"
      [attr.aria-label]="'COMMON.ACTION.CLOSE' | translate">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
</ng-template>
